import './notificationbadge.scss'

const notyIconStyle = {
    position: "relative",
    display: "inline",
    cursor: "pointer"
};

export default function NotificationBadge(props) {
    const { width, color, count, children } = props;
    return (
        <div onClick={props?.onClick}>
            <div style={notyIconStyle}>
                {count > 0 ? <div className="noty-badge-badge noty-badge-anchorOriginTopRightCircular noty-badge-colorSecondary">{count}</div> : null}

                <svg viewBox="0 0 25 25" width={width} fill={color}>
                    {children}
                </svg>
            </div>
        </div>
    );
}
